import { useEffect } from "react";

import { Layer, Map, GeoJSON } from "leaflet";

import { LayerStyles } from "types/types";

interface Props {
  mapRef: Map;
  studyAreaGeo: GeoJSON | Layer;
  studyAreaBuffer?: GeoJSON | Layer;
  renderBuffer?: boolean;
}
export function RenderStudyArea(props: Props) {
  const { mapRef, studyAreaGeo, studyAreaBuffer, renderBuffer = false } = props;
  useEffect(() => {
    if (!mapRef.hasLayer(studyAreaGeo)) {
      fitBounds(mapRef, studyAreaGeo, studyAreaBuffer);
    }

    if (renderBuffer && studyAreaBuffer) {
      renderLayer(studyAreaBuffer, mapRef, {
        fillColor: "#f1d39a",
        color: "transparent",
        fillOpacity: 0.4,
      });
    }

    renderLayer(studyAreaGeo, mapRef, {
      fillColor: "transparent",
      color: "purple",
      fillOpacity: 0,
    });

    function renderLayer(
      layer: GeoJSON | Layer,
      map: Map,
      layerStyles: LayerStyles
    ) {
      if (mapRef.hasLayer(layer)) return;
      // @ts-ignore
      layer.setStyle({ ...layerStyles });

      map.addLayer(layer);
    }

    function fitBounds(
      mapRef: Map,
      studyAreaGeo: GeoJSON | Layer,
      buffer?: GeoJSON | Layer
    ) {
      // @ts-ignore
      const bounds = studyAreaGeo.getBounds().pad(0.01);

      if (!buffer) {
        return mapRef.fitBounds(bounds);
      }
      // @ts-ignore
      const bufferBounds = buffer.getBounds();

      return mapRef.fitBounds(bufferBounds);
    }

    return function cleanUp() {
      if (mapRef.hasLayer(studyAreaGeo)) mapRef.removeLayer(studyAreaGeo);
      if (studyAreaBuffer && mapRef.hasLayer(studyAreaBuffer))
        mapRef.removeLayer(studyAreaBuffer);
    };
  }, [studyAreaGeo, mapRef, renderBuffer, studyAreaBuffer]);

  return null;
}
